export const FONT_SIZES = {
    CARD_TEXT: '12px',
    MAIN_TITLE: '24px',
    SECTION_TITLE: '20px',
    SUB_TITLE: '15px',
    REGULAR_TEXT: '15px',
}

export const FONT_WEIGHTS = {
    REGULAR: 400,
    SEMI_BOLD: 600
}
